const DEFAULT_TITLE = "Rising Stars Public School";
const DEFAULT_DESCRIPTION =
  "Rising Stars Public School offers quality education, holistic growth, and a vibrant learning environment.";

function upsertMeta(attr, key, content) {
  if (!content) return;
  const selector = `meta[${attr}="${key}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

function cleanText(value, fallback) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  return text || fallback;
}

export function applySeo({
  title,
  description,
  image,
  url,
  type = "website",
  robots,
} = {}) {
  const safeTitle = cleanText(title, DEFAULT_TITLE);
  const safeDescription = cleanText(description, DEFAULT_DESCRIPTION);
  const safeUrl = url || window.location.href;

  document.title = safeTitle;
  upsertMeta("name", "description", safeDescription);

  upsertMeta("property", "og:title", safeTitle);
  upsertMeta("property", "og:description", safeDescription);
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:url", safeUrl);
  if (image) {
    upsertMeta("property", "og:image", image);
  }

  upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  upsertMeta("name", "twitter:title", safeTitle);
  upsertMeta("name", "twitter:description", safeDescription);
  if (image) {
    upsertMeta("name", "twitter:image", image);
  }

  if (robots) {
    upsertMeta("name", "robots", robots);
  }

  upsertLink("canonical", safeUrl);
}

export { DEFAULT_TITLE, DEFAULT_DESCRIPTION };
